import store2 from 'store2';
import cjson from 'compressed-json';

// To disabled compression set to false
const USE_COMPRESSION = true;

const compress = originalData => {
  // only when compression is used
  if (USE_COMPRESSION) {
    return cjson.compress(originalData);
  }
  return originalData;
};

const decompress = compressedData => {
  // are these data really compressed?
  if (compressedData._) {
    return cjson.decompress(compressedData);
  }
  return compressedData;
};

const store = {
  session: {
    get: (key, alt) => store2.session.get(key, alt),
    getCompressedJSON: (key, alt) => decompress(store2.session.get(key, alt)),

    has: key => store2.session.has(key),

    set: (key, data, overwrite) => store2.session.set(key, data, overwrite),
    setCompressedJSON: (key, data, overwrite) => store2.session.set(key, compress(data), overwrite),

    remove: (key, alt) => store2.session.remove(key, alt),

    keys: () => store2.session.keys(),
    size: () => store2.session.size(),
  },

  get: (key, alt) => store2.get(key, alt),
  getCompressedJSON: (key, alt) => decompress(store2.get(key, alt)),

  set: (key, data, overwrite) => store2.set(key, data, overwrite),
  setCompressedJSON: (key, data, overwrite) => store2.set(key, compress(data), overwrite),

  remove: (key, alt) => store2.remove(key, alt),

  keys: () => store2.keys(),
  size: () => store2.size(),
};

export default store;
